import { useState } from 'react';
import './immersivo.css';
import { AvvioAtto } from './AvvioAtto';
import type { ScelteAtto } from './AvvioAtto';
import { EditorAtto } from './EditorAtto';
import type { Scheda } from './data/atti';

/**
 * Rotta /immersivo — la pagina «Da dove partiamo».
 *
 * Due fasi nella stessa rotta, non due rotte: la scelta di ente/tipo/format è
 * il preambolo dello stesso atto, e «Cambia format» deve riportare indietro
 * senza perdere il contesto.
 */
export function ImmersivoPage() {
  const [scelte, setScelte] = useState<ScelteAtto | null>(null);
  const [scheda, setScheda] = useState<Scheda>('guida');

  if (!scelte) {
    return (
      <div className="ui">
        <AvvioAtto onApri={(s, sch) => { setScelte(s); setScheda(sch ?? 'guida'); }} />
      </div>
    );
  }
  return <EditorAtto scelte={scelte} schedaIniziale={scheda} onIndietro={() => setScelte(null)} />;
}
